import Vue from "vue";
import App from "./search/Serp.vue";

Vue.config.productionTip = false;

new Vue({
    render: h => h(App),
}).$mount("#app");
